import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($state, $scope, Alert, ApplicationsResource) {
        this.$state = $state;
        this.$scope = $scope;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
    }

    update() {
        this.isSaving = true;
        this.ApplicationsResource
            .changeNonDomainComputerProtectionKey(this.companyId, this.application.id)
            .then(nonDomainProtectionKey => {
                this.Alert('success', 'company.manage-application.integration-developers.non-domain-protection-key.changed');
                this.application.nonDomainProtectionKey = nonDomainProtectionKey;
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.controller.js